import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { toast } from '@leadsnavi/ui-kit';

declare module 'axios' {
  interface InternalAxiosRequestConfig {
    skipAuthRedirect?: boolean;
    skipGlobalErrorHandling?: boolean;
  }
}

let isHandling401 = false;

export function createHttp(): AxiosInstance {
  const instance = axios.create({
    // baseURL: getEnv('VITE_API_BASE_URL'),
    // timeout: 15000,
  });

  instance.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
    // 后端根据这个标识 确定鉴权失败是 302到登录页 还是 返401，值为XMLHttpRequest时，返回401错误码
    config.headers.set('X-Requested-With', 'XMLHttpRequest');
    return config;
  });

  /**
   * 响应拦截器 - 处理认证错误和全局错误
   * 401 时：有登录态 → 清理并跳首页；无登录态 → 原地弹登录框
   */
  instance.interceptors.response.use(
    response => {
      const data = response?.data;
      const skipGlobalErrorHandling = response.config.skipGlobalErrorHandling;
      if (!data?.success && data.message) {
        // true, 不提示错误
        if (!skipGlobalErrorHandling) {
          // 自动提示错误
          toast.error(data.message, { richColors: true });
        }
        return Promise.reject(response?.data);
      }
      return response;
    },
    async (error: AxiosError) => {
      const config = error.config as InternalAxiosRequestConfig;

      // 如果配置了跳过认证重定向，直接返回错误
      if (config?.skipAuthRedirect) {
        return Promise.reject(error);
      }

      if (error.response?.status === 401) {
        if (!isHandling401) {
          isHandling401 = true;

          const { default: useUserStore } = await import('@/stores/userStore');
          const wasLoggedIn = !!useUserStore.getState().user;

          if (wasLoggedIn) {
            useUserStore.getState().cleanupAuth();
            window.location.href = '/';
          } else {
            isHandling401 = false;
            const { authModalService } = await import('@/services/authModal');
            authModalService.openLogin();
          }
        }
        return Promise.reject(error);
      }

      return Promise.reject(error);
    }
  );

  return instance;
}

/**
 * 导出HTTP实例
 * 设计思路：提供统一的HTTP客户端，所有API请求都通过此实例进行
 */
export const http = createHttp();
